// src/components/Particles.jsx
import { useEffect, useRef } from "react";
import { PARTICLE_COLORS } from "../utils/constants";

export default function Particles() {
  const ref = useRef(null);
  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    for (let i = 0; i < 55; i++) {
      const p = document.createElement("div");
      p.className = "toa-p";
      const s = 1 + Math.random() * 3;
      p.style.cssText = `left:${Math.random() * 100}vw;width:${s}px;height:${s}px;background:${
        PARTICLE_COLORS[Math.floor(Math.random() * PARTICLE_COLORS.length)]
      };animation-duration:${9 + Math.random() * 18}s;animation-delay:${Math.random() * 16}s`;
      container.appendChild(p);
    }
  }, []);
  return <div className="toa-particles" ref={ref} />;
}
